import { ConsentsSlugEnum } from '.spec/self-care/tsTypes';

/**
 * Souhlas se zasíláním novinek. Implicitně uděluje každý uživatel použítím naší
 * služby (tzv. "oprávněný zájem").
 * @type {string}
 */
export const { MARKETING } = ConsentsSlugEnum;
/**
 * Souhlas se zasíláním rozšířených novinek.
 * @type {string}
 */
export const { MARKETING_EXTENDED } = ConsentsSlugEnum;
/**
 * Souhlas s uložením osobních údajů v našem systému.
 * @type {string}
 */
export const { REGISTRATION } = ConsentsSlugEnum;
/**
 * Souhlas s provedením scoringu se základní množinou dat.
 * @type {string}
 */
export const SCORING_DATA_BASIC = 'SCORING_DATA_BASIC';
/**
 * Souhlas s provedením scoringu nad daty získaných ze zařízení.
 * @type {string}
 */
export const SCORING_DATA_DEVICE = 'SCORING_DATA_DEVICE';
/**
 * Souhlas s provedením scoringu s rozšířenou množinou dat.
 * @type {string}
 */
export const SCORING_DATA_EXTENDED = 'SCORING_DATA_EXTENDED';
/**
 * Souhlas s provedením scoringu nad daty historických objednávek z e-shopu.
 * @type {string}
 */
export const SCORING_DATA_HISTORICAL_ORDERS = 'SCORING_DATA_HISTORICAL_ORDERS';
/**
 * Souhlas s provedením scoringu nad daty chování zákazníka na e-shopu a bráně.
 * @type {string}
 */
export const SCORING_DATA_WEB_BEHAVIOUR = 'SCORING_DATA_WEB_BEHAVIOUR';
/**
 * Souhlas s provedením prechecku.
 * @type {string}
 */
export const SCORING_PRECHECK = 'SCORING_PRECHECK';
/**
 * Souhlas se zpracováváním RČ.
 * @type {string}
 */
export const STORE_PERSONAL_ID = 'STORE_PERSONAL_ID';
/**
 * Souhlas s předáním dat Homecredit a využití získaných dat do scoringu.
 * @type {string}
 */
export const THIRD_PARTY_HOMECREDIT = 'THIRD_PARTY_HOMECREDIT';
/**
 * Souhlas s předáním dat a RČ do ISIR a využití získaných dat do scoringu.
 * @type {string}
 */
export const THIRD_PARTY_INSOLVENCY = 'THIRD_PARTY_INSOLVENCY';
/**
 * Souhlas s předáním dat a RČ do SOLUS a využití získaných dat do scoringu.
 * @type {string}
 */
export const THIRD_PARTY_SOLUS = 'THIRD_PARTY_SOLUS';
/**
 * Souhlas s předáním dat operátorům (O2, T-Mobile a Vodafone) a využití dat do scoringu.
 * @type {string}
 */
export const THIRD_PARTY_TELCO = 'THIRD_PARTY_TELCO';
